import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import moment from 'moment';
import { toast } from 'react-toastify';

const EditDisplay = {
    name: 'EditDisplay',
    state: {
        loading: false,
        error: '',
        confirmed: '',
        playlist_overbooked: false,
        playlist_data: null,

    },
    reducers: {
        assignRequested(state) {
            return {
                ...state,
                loading: true,
                error: '',
                confirmed: '',
            };
        },

        assignSucceeded(state) {
            return {
                ...state,
                loading: false,
                confirmed: 'Rate Replaced successfully',
                error: '',
            };
        },

        assignFailed(state, payload) {
            return {
                ...state,
                loading: false,
                error: payload,
                confirmed: payload,
            };
        },
        setPlaylistOverbooked(state, payload) {
            return {
                ...state,
                playlist_overbooked: true,
                playlist_data: payload || null,
                loading: false,
                error: payload,
                confirmed: payload,
            };
        },
        resetState(state) {
            return {
                ...state,
                loading: false,
                error: '',
                confirmed: '',
            };
        }
    },
    effects: (dispatch) => ({
        async EditDisplay({ Id, name, visibility, rate_schedule_id, file }) {
            try {
                this.assignRequested();
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const url = `savvy/displays/edit/${Id}`;
                // visibility_status is determined by rate_schedule assignment
                const visibilityStatus = rate_schedule_id ? 'available' : 'unavailable';
                const formData = new FormData();
                const generalInfo = {
                    name,
                    visibilityStatus,
                    visibility,
                    rate_schedule_id,
                    user_id: userInfo.id,
                    org_id: userInfo.org_id,
                };

                formData.append('file', file);

                Object.entries(generalInfo).forEach(([key, value]) => {
                    formData.append(`generalInfo[${key}]`, value);
                });

                const response = await http.put(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                if (response && response?.data?.message === "display_updated_successfully") {
                    this.assignSucceeded();
                    dispatch({
                        type: 'helper/show',
                        payload: {
                            type: 'success',
                            message: 'Display Updated successfully!',
                            show: true,
                        },
                    });
                }
            } catch (err) {
                this.assignFailed(err.message);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async RemoveSpecializedRateScheduleFromDisplay({ id, rate_id }) {
            try {
                this.assignRequested();
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const user_id = userInfo.id;
                const org_id = userInfo.org_id;
                const url = `savvy/displays/remove-specialized-rate/${id}?rate_id=${rate_id}&user_id=${user_id}&org_id=${org_id}`;
                const response = await http.put(url);

                if (response && response?.data?.message === "Specialized Rate Schedule removed successfully") {
                    this.assignSucceeded();
                    dispatch({
                        type: 'helper/show',
                        payload: {
                            type: 'success',
                            message: 'Specialized Rate Removed successfully!',
                            show: true,
                        },
                    });
                    setTimeout(() => {
                        toast.success('Specialized Rate Removed successfully!');
                    }, 400);


                } else {
                    if (response && response?.data?.message === "Playlist Overbooked") {
                        this.assignSucceeded();
                        dispatch({
                            type: 'helper/show',
                            payload: {
                                type: 'success',
                                message: `Removal is not possible due to playlist overbooked by ${response?.data?.data} seconds`,
                                data: response?.data?.data,
                                show: true,
                            },
                        });
                        setTimeout(() => {
                            toast.warn(`Removal is not possible due to playlist overbooked by ${response?.data?.data} seconds`);
                        }, 400);
                    }
                }
            } catch (err) {
                this.assignFailed(err.message);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async RemoveEntireRateScheduleFromDisplay(payload) {
            try {
                this.assignRequested();
                const id = payload.display_id;
                const org_id = JSON.parse(localStorage.getItem('userInfo')).org_id;
                // Prepare a compact, normalized payload for the API
                const formatZone = (zone) => ({
                    ...zone,
                    // Normalize legacy mixed/multi media labels to canonical 'Mixed'
                    media_type: zone?.media_type === 'Still / Video' ? 'Mixed' : zone?.media_type,
                    // Preserve full-screen flag for backend processing
                    isFullScreen: !!zone?.isFullScreen,
                    priceSchedules: {
                        ...zone?.priceSchedules,
                        dateRange: {
                            ...zone?.priceSchedules?.dateRange,
                            startDate: zone?.priceSchedules?.dateRange?.startDate
                                ? moment(zone?.priceSchedules?.dateRange?.startDate).format('YYYY-MM-DD')
                                : null,
                            endDate: zone?.priceSchedules?.dateRange?.endDate
                                ? moment(zone?.priceSchedules?.dateRange?.endDate).format('YYYY-MM-DD')
                                : null,
                        },
                        specifiedDates: {
                            ...zone?.priceSchedules?.specifiedDates,
                            datesData: zone?.priceSchedules?.specifiedDates?.datesData
                                ? zone.priceSchedules.specifiedDates.datesData.map(dateEntry => ({
                                    ...dateEntry,
                                    date: moment(dateEntry.date).format('YYYY-MM-DD')
                                }))
                                : [],
                        }
                    }
                });

                const normalizeSchedule = (schedule) => {
                    if (!schedule) return schedule;
                    const zones = Array.isArray(schedule.zones)
                        ? schedule.zones.map(formatZone)
                        : schedule.zones;
                    return {
                        ...schedule,
                        zones,
                    };
                };

                const normalizedPayload = {
                    ...payload,
                    default: Array.isArray(payload.default) ? payload.default.map(normalizeSchedule) : normalizeSchedule(payload.default),
                    specialized: Array.isArray(payload.specialized) ? payload.specialized.map(normalizeSchedule) : normalizeSchedule(payload.specialized),
                };

                const data = {
                    ...normalizedPayload,
                    user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                    org_id: org_id,
                };
                // const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const url = `savvy/displays/remove-entire-rate/${id}`;
                const response = await http.put(url, data);

                if (response && response?.data?.message === "entire_rate_replace_successfully") {
                    this.assignSucceeded();
                    dispatch({
                        type: 'helper/show',
                        payload: {
                            type: 'success',
                            message: 'Entire Rate Replaced successfully!',
                            show: true,
                        },
                    });
                }
            } catch (err) {
                const serverMsg = err?.response?.data?.message;
                if (serverMsg === 'playlist_check_failed') {
                    // this.assignFailed('playlist_check_failed');
                    // set playlist overbooked state for UI if needed
                    this.setPlaylistOverbooked(err?.response?.data || null);
                    // show toast for 5 seconds
                    toast.warn('Playlist overbooked. Please adjust ad allocation or schedules.', { autoClose: 5000 });
                    return;
                }

                this.assignFailed(err.message);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
    }),
    resetState(state) {
        this.resetState();
    }
};

export default EditDisplay;


